import React, { createContext, useState, useEffect } from 'react';
import {API_URL, WHITELABEL_ID} from '../constants';
import axios from 'axios';
import Spinner from "react-bootstrap/Spinner";


export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/api/wl/${WHITELABEL_ID}/appconfig`, 
      {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
      })
        .then(response => {
            setConfig(response.data);
        })
        .catch(err => console.error('Failed to load config:', err))
        .finally(() => {
    
        });
  }, []);

  return (
    <ConfigContext.Provider value={config}>
      {config ? children : (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Spinner animation="border" role="status">
            <span className="visually-hidden"></span>
          </Spinner>
        </div>
      )}
    </ConfigContext.Provider>
  );
};